<template>
  <div class="home">
    <div class="home_h">
      <img src="~@/assets/home/head.png" alt="" />
      <img src="~@/assets/home/biao.png" alt="" class="image" @click="handleHome" />
    </div>
    <div class="home_time">
      {{ currentTime }}
      <div class="tui"  @click="toggleFullScreen">{{ isFullscreen ? '退出全屏' : '全屏' }}</div>
    </div>
    <div class="home_c">
      <div class="home_l">
        <div class="home_l_p">
          <img src="~@/assets/home/quyu.png" alt="" class="home_l_i" />
        </div>
        <div class="home_q">
          <div class="item">
            <div>区域名称</div>
            <div class="item_t">订单数量</div>
            <div class="item_t">经销商数量</div>
          </div>
          <div class="home_q_h">
            <template v-if="regionTops && regionTops.length">
              <div class="item" v-for="(item, index) in regionTops" :key="index">
                <div>{{ item.name }}</div>
                <div class="item_t">{{ item.orderCount }}</div>
                <div class="item_t">{{ item.dealerCount }}</div>
              </div>
            </template>
            <div class="zan" v-else>
              <img src="~@/assets/home/zanwu.png" alt="" />
              <div>暂无数据</div>
            </div>
          </div>
        </div>
        <div class="home_l_p">
          <img src="~@/assets/home/quyu2.png" alt="" class="home_l_i" />
        </div>
        <div class="home_l_y home_l_p">
          <div class="home_l_d">
            <div></div>
            员工比例
          </div>
        </div>
        <div class="home_l_b">
          <homeBar :chartData="chartData3" v-if="chartData3 && chartData3.waterCount && chartData3.waterCount.length">
          </homeBar>
          <div class="zan" v-else>
            <img src="~@/assets/home/zanwu.png" alt="" />
            <div>暂无数据</div>
          </div>
        </div>
        <div class="home_l_y home_l_m">
          <div class="home_l_d">
            <div></div>
            服务工单
          </div>
          <div class="home_l_s">
            <a-select show-search v-model="params.regionId" placeholder="请选择" option-filter-prop="children"
              @change="getQuote" :filter-option="filterOption">
              <a-select-option v-for="d in quList" :key="d.id">{{ d.name }}</a-select-option>
            </a-select>
          </div>
        </div>
        <div class="home_l_b">
          <homeLine :chartData="chartData" v-if="chartData && chartData.waterCount && chartData.waterCount.length">
          </homeLine>
          <div class="zan" v-else>
            <img src="~@/assets/home/zanwu.png" alt="" />
            <div>暂无数据</div>
          </div>
        </div>
      </div>
      <div class="home_c_y home_l_p">
        <div class="home_c_t">
          <div class="home_c_t_i" @click="handleLook(0)">
            <div class="home_c_t_l">
              <img src="~@/assets/home/jing_1.png" alt="" v-if="sortType == 0" />
              <img src="~@/assets/home/jing.png" alt="" v-else />
            </div>
            <div class="home_c_r">
              <div :class="sortType == 0 ? 'home_c_d' : ''">
                {{ statistics01.byVolumeOfSales ? statistics01.byVolumeOfSales : 0 }}
              </div>
              经销商
            </div>
          </div>
          <div class="home_c_t_i" @click="handleLook(2)">
            <div class="home_c_t_l">
              <img src="~@/assets/home/shui_1.png" alt="" v-if="sortType == 2" />
              <img src="~@/assets/home/shui.png" alt="" v-else />
            </div>
            <div class="home_c_r">
              <div :class="sortType == 2 ? 'home_c_d' : ''">
                {{ statistics01.quantityOfHydraulicWork ? statistics01.quantityOfHydraulicWork : 0 }}
              </div>
              水工
            </div>
          </div>
          <div class="home_c_t_i" @click="handleLook(1)">
            <div class="home_c_t_l">
              <img src="~@/assets/home/yan_1.png" alt="" v-if="sortType == 1" />
              <img src="~@/assets/home/yan.png" alt="" v-else />
            </div>
            <div class="home_c_r">
              <div :class="sortType == 1 ? 'home_c_d' : ''">
                {{ statistics01.numberOfPressureTesters ? statistics01.numberOfPressureTesters : 0 }}
              </div>
              验收员
            </div>
          </div>
          <div class="home_c_t_i" @click="handleLook(3)">
            <div class="home_c_t_l">
              <img src="~@/assets/home/ding_3.png" alt="" v-if="sortType == 3" />
              <img src="~@/assets/home/ding.png" alt="" v-else />
            </div>
            <div class="home_c_r">
              <div :class="sortType == 3 ? 'home_c_d' : ''">
                {{ statistics01.completed ? statistics01.completed : 0 }}
              </div>
              订单
            </div>
          </div>
        </div>
        <div class="home_c_c">
          <div class="home_c_c_r">
            <mapChart :province02s="province02s" v-if="province02s && province02s.length"></mapChart>
          </div>
          <div class="home_c_c_t">
            <div>
              <a-select show-search v-model="time" placeholder="请选择" option-filter-prop="children"
                :filter-option="filterOption" @change="handleChange">
                <a-select-option v-for="d in timeList" :key="d.id">{{ d.name }}</a-select-option>
              </a-select>
              <!-- <a-range-picker v-model="value2" @change="handleChange" format="YYYY-MM-DD " /> -->
            </div>
          </div>
          <div class="home_c_c_l">
            <div>
              <div class="home_c_c_l_i" v-for="(item, index) in publicList" :key="index">
                <div class="item_1"></div>
                <div class="item_2">{{ item.name }}</div>
                <div>{{ item.count }}</div>
              </div>
            </div>
          </div>

          <!-- <div></div> -->
        </div>
        <div class="home_c_f">
          <div class="home_c_f_l">
            <div class="home_c_f_t">
              <div></div>
              水工单数
            </div>
            <homeBarTwo :chartData="chartData1"
              v-if="chartData1 && chartData1.orderCount && chartData1.orderCount.length">
            </homeBarTwo>
            <div class="zan" v-else>
              <img src="~@/assets/home/zanwu.png" alt="" />
              <div>暂无数据</div>
            </div>
          </div>
          <div class="home_c_f_r home_c_f_l">
            <div class="home_c_f_t">
              <div></div>
              水工占比
            </div>
            <homePie :chartData="chartData2" v-if="chartData2 && chartData2.date && chartData2.date.length"></homePie>
            <div class="zan" v-else>
              <img src="~@/assets/home/zanwu.png" alt="" />
              <div>暂无数据</div>
            </div>
          </div>
        </div>
      </div>
      <div class="home_r">
        <img src="~@/assets/home/fuwu.png" alt="" class="home_l_i" />
        <div class="home_r_t">
          <div class="home_r_t_y">
            <div class="home_r_t_u">
              <img src="~@/assets/home/d-1.png" alt="" />
            </div>
            <div class="home_r_r">
              <div>{{ statistics01.pendingOrder ? statistics01.pendingOrder : 0 }}</div>
              待接单
            </div>
          </div>
          <div class="home_r_t_y">
            <div class="home_r_t_u">
              <img src="~@/assets/home/d-2.png" alt="" />
            </div>
            <div class="home_r_r">
              <div>{{ statistics01.orderToBeSent ? statistics01.orderToBeSent : 0 }}</div>
              待派单
            </div>
          </div>
          <div class="home_r_t_y">
            <div class="home_r_t_u">
              <img src="~@/assets/home/d-3.png" alt="" />
            </div>
            <div class="home_r_r">
              <div>{{ statistics01.haveAccepted ? statistics01.haveAccepted : 0 }}</div>
              待试压
            </div>
          </div>
          <div class="home_r_t_y">
            <div class="home_r_t_u">
              <img src="~@/assets/home/d-4.png" alt="" />
            </div>
            <div class="home_r_r">
              <div>{{ statistics01.completed ? statistics01.completed : 0 }}</div>
              已完成
            </div>
          </div>
          <div class="home_r_t_y">
            <div class="home_r_t_u">
              <img src="~@/assets/home/d-5.png" alt="" />
            </div>
            <div class="home_r_r">
              <div>{{ statistics01.toBeReviewed ? statistics01.toBeReviewed : 0 }}</div>
              待审核
            </div>
          </div>
          <div class="home_r_t_y">
            <div class="home_r_t_u">
              <img src="~@/assets/home/d-6.png" alt="" />
            </div>
            <div class="home_r_r">
              <div>{{ statistics01.haveBeenCancelled ? statistics01.haveBeenCancelled : 0 }}</div>
              已作废
            </div>
          </div>
        </div>
        <img src="~@/assets/home/paihang.png" alt="" class="home_l_i" />
        <div>
          <!-- <homePie :chartData="chartData4" v-if="chartData4 && chartData4.date && chartData4.date.length"></homePie> -->

          <homePieTwo :chartData="chartData4" v-if="chartData4 && chartData4.date && chartData4.date.length">
          </homePieTwo>

          <!-- <div class="zan" v-else>
            <img src="~@/assets/home/zanwu.png" alt="" />
            <div>暂无数据</div>
          </div> -->
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import homeBar from '../Charts/homeBar.vue'
import homeLine from '../Charts/homeLine.vue'
import mapChart from '../Charts/map.vue'
import homeBarTwo from '../Charts/homeBarTwo.vue'
import homePie from '../Charts/homePie.vue'
import homePieTwo from '../Charts/homePieTwo.vue'
import { Modal } from 'ant-design-vue'
import { largeScreen, largeScreenRegion } from '@/api/system/user'
import { mapSort } from '@/api/pressure/home'
import { regionList } from '@/api/pressure/region'
import { mapGetters } from 'vuex'
import moment from 'moment'
import setting from '@/locales/lang/zh-CN/setting'

export default {
  name: 'HomePage',
  components: {
    homeBar,
    homeLine,
    mapChart,
    homeBarTwo,
    homePie,
    homePieTwo,
  },
  data() {
    return {
      isFullscreen: false,
      currentTime: '',
      regionId: undefined,
      quList: [],
      chartData: {},
      statistics01: {},
      value2: [],
      chartData1: {},
      regionTops: [],
      chartData2: {},
      chartData3: {},
      chartData4: {},
      province02s: [],
      createBeginTime: '',
      createEndTime: '',
      publicList: [],
      sortType: 0,
      time: 0,
      timeList: [
        { id: 0, name: '全部' },
        { id: 1, name: '今天' },
        { id: 2, name: '本周内' },
        { id: 3, name: '本月内' },
        { id: 4, name: '三月内' },
        { id: 5, name: '六月内' },
        { id: 6, name: '本年内' },
      ],
      params: {
        tenantId: '',
        regionId: undefined,
        type: '',
      },
    }
  },
  watch: {},
  mounted() {
    // 页面加载完成后开始更新当前时间
    this.updateTime() // 初始化时间
    this.timeInterval = setInterval(this.updateTime, 1000) // 每秒更新一次
    this.handleLook(this.sortType)
    // 初始状态检测
    this.isFullscreen = !!this.getFullscreenElement();

    // 添加全屏状态监听（兼容不同浏览器）
    document.addEventListener('fullscreenchange', this.handleFullscreenChange);
    document.addEventListener('webkitfullscreenchange', this.handleFullscreenChange);
    document.addEventListener('mozfullscreenchange', this.handleFullscreenChange);
    document.addEventListener('MSFullscreenChange', this.handleFullscreenChange);
  },
  computed: {
    hasPermission() {
      return (permission) => {
        console.log(this.userType, '测试type====')
        if (this.$store.state.user.userTentant.type === 0) {
          return true
        } else {
          return this.$store.state.user.permissions.includes(permission)
        }
        // return true
      }
    },
    userType() {
      return this.$store.state.user.userTentant.type
    },
    ...mapGetters(['menus', 'userTentant']),
  },
  beforeDestroy() {
    // 清除定时器
    clearInterval(this.timeInterval)
    // 移除监听
    document.removeEventListener('fullscreenchange', this.handleFullscreenChange);
    document.removeEventListener('webkitfullscreenchange', this.handleFullscreenChange);
    document.removeEventListener('mozfullscreenchange', this.handleFullscreenChange);
    document.removeEventListener('MSFullscreenChange', this.handleFullscreenChange);
  },
  created() {
    console.log(11111, '顶顶顶顶')
    // console.log(defaultSettings,'defaultSettingsdefaultSettings');
    // this.params=this.this.$store.state.user.userTentant
    this.params.tenantId = this.$store.state.user.userTentant.tenantId
    console.log(this.userType, 'this.userTypethis.userType')
    if (this.userType === 1 || this.userType === 0) {
      this.getQu()
      this.getDate()
    }
    console.log(this.$store.state.user.userTentant, 'this.$store.state.user.userTentant')
  },
  methods: {
    filterOption(input, option) {
      return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
    },
    // 获取全屏元素（兼容不同浏览器）
    getFullscreenElement() {
      return (
        document.fullscreenElement ||
        document.webkitFullscreenElement ||
        document.mozFullScreenElement ||
        document.msFullscreenElement
      );
    },
    // 全屏切换方法
    async toggleFullScreen() {
      // this.fullscreenLoading = true;
      try {
        // 当前是全屏状态 → 退出全屏
        if (this.isFullscreen) {
          if (document.exitFullscreen) {
            await document.exitFullscreen();
          } else if (document.webkitExitFullscreen) {
            await document.webkitExitFullscreen();
          } else if (document.mozCancelFullScreen) {
            await document.mozCancelFullScreen();
          } else if (document.msExitFullscreen) {
            await document.msExitFullscreen();
          }
          // message.success('已退出全屏');
        }
        // 当前非全屏状态 → 进入全屏
        else {
          const docEl = document.documentElement;
          if (docEl.requestFullscreen) {
            await docEl.requestFullscreen();
          } else if (docEl.webkitRequestFullscreen) {
            await docEl.webkitRequestFullscreen();
          } else if (docEl.mozRequestFullScreen) {
            await docEl.mozRequestFullScreen();
          } else if (docEl.msRequestFullscreen) {
            await docEl.msRequestFullscreen();
          }
          message.success('已进入全屏');
        }
      } catch (error) {
        console.error('全屏操作失败:', error);
        message.error('全屏操作失败，请检查浏览器权限');
      } finally {
        // this.fullscreenLoading = false;
      }
    },
    // 监听全屏状态变化
    handleFullscreenChange() {
      this.isFullscreen = !!this.getFullscreenElement();
    },
    handleChange(e) {
      console.log(e, '顶顶顶顶对面')
      if (e == 0) {
        this.createBeginTime = ''
        this.createEndTime = ''
      } else if (e == 1) {
        // 今天
        this.createBeginTime = moment().startOf('day').format('YYYY-MM-DD HH:mm:ss')
        this.createEndTime = moment().endOf('day').format('YYYY-MM-DD HH:mm:ss')
      } else if (e == 2) {
        // 本周
        this.createBeginTime = moment().startOf('week').format('YYYY-MM-DD HH:mm:ss')
        this.createEndTime = moment().endOf('week').format('YYYY-MM-DD HH:mm:ss')
      } else if (e == 3) {
        // 本月
        this.createBeginTime = moment().startOf('month').format('YYYY-MM-DD HH:mm:ss')
        this.createEndTime = moment().endOf('day').format('YYYY-MM-DD HH:mm:ss')
      } else if (e == 4) {
        // 三月内
        this.createBeginTime = moment().subtract(90, 'days').startOf('day').format('YYYY-MM-DD HH:mm:ss')
        this.createEndTime = moment().endOf('day').format('YYYY-MM-DD HH:mm:ss')
      } else if (e == 5) {
        // 六月内
        this.createBeginTime = moment().subtract(180, 'days').startOf('day').format('YYYY-MM-DD HH:mm:ss')
        this.createEndTime = moment().endOf('day').format('YYYY-MM-DD HH:mm:ss')
      } else if (e == 6) {
        this.createBeginTime = moment().startOf('year').format('YYYY-MM-DD HH:mm:ss')
        this.createEndTime = moment().endOf('day').format('YYYY-MM-DD HH:mm:ss')
      }
      this.handleLook(this.sortType)
      console.log(this.createBeginTime, ' this.createBeginTime')
      console.log(this.createEndTime, ' this.createEndTime')
    },
    // 点击查看数据
    handleLook(e) {
      this.sortType = e
      // console.log(this.province02s, 'province02sprovince02s')
      // this.
      // this.
      const query = {
        sortType: e,
        type: this.userType,
        tenantId: this.userTentant.tenantId,
        createBeginTime: this.createBeginTime,
        createEndTime: this.createEndTime,
      }
      console.log(query, 'queryquery')

      mapSort(query).then((res) => {
        console.log(res, '顶顶顶顶')
        this.publicList = res.data
      })
    },

    getQu() {
      regionList().then((res) => {
        console.log(res, '的点点滴滴')
        this.quList = res.data
        this.params.regionId = res.data[0].id
        this.getQuote()
      })
    },
    // 查询所有参数数据
    getDate() {
      largeScreen(this.params).then((res) => {
        console.log(res, '谁 ===')
        res = res.data
        this.statistics01 = res.statistics01
        //  res.waterTops
        // let waterTops = []
        if (res.waterTops && res.waterTops.length) {
          res.waterTops.sort((a, b) => a.orderCount - b.orderCount)
        }
        // 水工工单
        this.chartData1 = {
          name: res.waterTops.map((v) => v.name),
          orderCount: res.waterTops.map((v) => v.orderCount),
        }
        console.log()
        // // 水工各区域的占比
        const arr = []
        if (res.waterRegions && res.waterRegions.length) {
          res.waterRegions.forEach((v) => {
            arr.push({ name: v.name, value: v.waterCount })
          })
          this.chartData2 = {
            date: arr,
          }
          this.chartData3 = {
            name: res.regionStaffs.map((v) => v.name),
            examinerCount: res.regionStaffs.map((v) => v.examinerCount),
            waterCount: res.regionStaffs.map((v) => v.waterCount),
          }
        }
        if (res.province02s && res.province02s.length) {
          const array = []
          res.province02s.forEach((v) => {
            if (v.provinceCode) {
              array.push(v)
            }
          })
          this.province02s = array
          console.log(this.province02s, 'this.province02s')
        }
        console.log(res.regionTops, 'res.regionTops')
        if (res.regionTops && res.regionTops.length) {
          this.regionTops = res.regionTops
          const datu = []
          res.regionTops.forEach((v) => {
            datu.push({ name: v.name, value: v.orderCount })
          })
          // let yu = [
          //   { value: 1048, name: 'Search Engine' },
          //   { value: 735, name: 'Direct' },
          //   { value: 580, name: 'Email' },
          //   { value: 484, name: 'Union Ads' },
          //   { value: 300, name: 'Video Ads' },
          // ]
          // 排行比
          setTimeout(() => {
            this.chartData4 = {
              date: datu,
            }
          }, 100)
          this.$forceUpdate()
          console.log(this.chartData4, 'chartData4chartData4')
        }
        console.log(this.province02s, 'province02sprovince02sprovince02s')
        // 区域排行
      })
    },
    // 查询区域
    getQuote() {
      largeScreenRegion(this.params).then((res) => {
        console.log(res, '测试薪水')
        const date = res.data
        this.chartData = {
          mon: date.map((v) => v.mon),
          examinerCount: date.map((v) => v.examinerCount),
          waterCount: date.map((v) => v.waterCount),
          orderCount: date.map((v) => v.orderCount),
        }
      })
    },
    handleHome() {
      // console.log(this.menus,'menusmenusmenus')
      this.$router.back()
      // this.$router.push('/')
    },
    // 退出登录
    hanldeTui() {
      const that = this
      Modal.confirm({
        title: '提示',
        content: '确定退出系统吗？',
        okText: '确定', // 手动指定按钮文字
        cancelText: '取消',
        onOk: () => {
          return this.$store.dispatch('Logout').then((res) => {
            that.$router.push({ path: 'user/login' })
            location.href = '/'
            // that.$router.push({ name: 'login' })
          })
          // that.$router.push({ name: 'logout' })
        },
        onCancel() { },
      })
    },
    updateTime() {
      const now = new Date()
      const year = now.getFullYear()
      const month = (now.getMonth() + 1).toString().padStart(2, '0') // 月份从 0 开始，补充两位
      const day = now.getDate().toString().padStart(2, '0')
      const hours = now.getHours().toString().padStart(2, '0')
      const minutes = now.getMinutes().toString().padStart(2, '0')
      const seconds = now.getSeconds().toString().padStart(2, '0')
      // 格式化为 YYYY-MM-DD HH:mm:ss
      this.currentTime = `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`
    },
  },
}
</script>
<style lang="less" scoped>
.home {
  width: 100%;
  height: 100vh;
  background: url(../../assets/home/home.png) no-repeat;
  background-size: 100% 100%;
  position: relative;

  .home_l_i {
    width: 100%;
    height: 36px;
    margin-bottom: 10px;
  }

  .home_h {
    width: 100%;
    height: 85px;
    position: relative;

    img {
      width: 100%;
      height: 85px;
    }

    .image {
      width: 247px;
      height: 47px;
      position: absolute;
      top: 10px;
      //   top: 50%;
      left: 50%;
      //   transform: translate(-50%, -50%);
      transform: translateX(-50%);
      cursor: pointer;
    }
  }

  .home_time {
    position: absolute;
    top: 40px;
    left: 0px;
    font-size: 20px;
    color: #fff;
    width: 100%;
    padding-left: 20px;
    padding-right: 40px;

    display: flex;
    justify-content: space-between;

    .tui {
      cursor: pointer;
    }
  }

  .home_c {
    padding: 0 20px;
    width: 100%;
    height: 86vh;
    display: flex;
    justify-content: space-between;

    // .home_l_p {
    //   padding: 0 20px;
    // }
    .home_l {
      background: rgba(77, 90, 144, 0.33);
      height: 100%;
      border-radius: 16px;
      width: 350px;
      // padding-top: 15px;
      padding: 15px 20px 0;

      .home_q {
        .home_q_h {
          max-height: 100px;
          height: 100px;
          // background: red;
          overflow-y: auto;

          /* 设置滚动条的宽度 */
          &::-webkit-scrollbar {
            width: 10px;
            /* 滚动条宽度 */
          }

          // /* 设置滚动条轨道的背景颜色 */
          // ::-webkit-scrollbar-track {
          //   background-color: #f1f1f1;
          // }

          // /* 设置滚动条滑块的背景颜色 */
          // ::-webkit-scrollbar-thumb {
          //   background-color: #888;
          // }

          // /* 设置滚动条滑块悬停时的背景颜色 */
          // ::-webkit-scrollbar-thumb:hover {
          //   background-color: #555;
          // }
        }

        .item {
          display: flex;
          align-items: center;
          //   background: red;
          color: #fff;
          justify-content: space-between;
          margin-bottom: 8px;

          //   .item_t {
          //     width: 30%;
          //     // background: red;
          //   }
          div {
            width: 33.5%;
            // text-align: left;
            text-align: center;

            &:last-child {
              color: #d8ba49;
            }
          }
        }
      }

      .home_l_y {
        display: flex;
        align-items: center;
        color: #fff;
        padding-left: 10px;
        margin-bottom: 10px;
        justify-content: space-between;

        .home_l_d {
          display: flex;
          align-items: center;

          div {
            width: 3px;
            height: 10px;
            background: #facc14;
            margin-right: 10px;
          }
        }

        .home_l_s {
          width: 150px;

          /deep/ .ant-select {
            width: 150px !important;
          }

          /deep/.ant-select-selection--single {
            background: #051a39 !important;
            height: 20px !important;
            font-size: 14px !important;
          }

          /deep/.ant-select-arrow-icon {
            color: #fff;
            height: 20px !important;
            font-size: 14px !important;
          }

          /deep/.ant-select-selection__placeholder,
          /deep/.ant-select-selection-selected-value {
            font-size: 10px !important;
            line-height: 20px !important;
            color: #fff !important;
          }

          /deep/.ant-select-selection__rendered {
            height: 20px !important;
          }
        }
      }

      .home_l_b {
        // background: red;
      }
    }

    .home_c_y {
      flex: 1;
      margin: 0 10px;

      .home_c_t {
        display: flex;
        align-items: center;
        justify-content: space-around;
        // background: red;
        width: 100%;

        .home_c_t_i {
          z-index: 666;
          display: flex;
          align-items: center;
          cursor: pointer !important;

          // background: red;
          .home_c_t_l {
            width: 39px;
            height: 39px;
            border: 1px solid #abcbff;
            display: flex;
            align-items: center;
            justify-content: center;
            margin-right: 10px;

            img {
              width: 29px;
              height: 29px;
            }
          }

          .home_c_r {
            color: #fff;

            div {
              font-size: 24px;
              color: #84cee6;
              font-weight: 500;
            }

            .home_c_d {
              color: #d8ba49;
            }
          }
        }
      }

      .home_c_c {
        // background: red;
        height: 50vh;
        display: flex;
        justify-content: space-between;
        // background: red;
        position: relative;

        .home_c_c_t {
          position: relative;
          position: absolute;
          right: 0;
          top: 20px;
          width: 200px !important;
          // background: red;
          // height: 50px;
          box-sizing: border-box;

          /deep/.ant-select-selection--single {
            width: 200px !important;
            color: #fff;
            background: transparent !important;

            .anticon>* {
              color: #fff;
            }
          }
        }

        .home_c_c_l {
          position: absolute;
          right: 0;
          bottom: 0;
          width: 200px;
          color: #fff;
          display: flex;
          align-items: center;
          padding-left: 30px;
          // height: 50vh;
          // background: red;

          .home_c_c_l_i {
            display: flex;
            align-items: center;
            margin-bottom: 8px;

            .item_1 {
              width: 15px;
              height: 15px;
              background: #1684fc;
              margin-right: 10px;
            }

            .item_2 {
              width: 70px;
              // background: red;
              margin-right: 5px;
            }

            &:nth-child(2n) {
              .item_1 {
                background: #ffffff;
              }
            }
          }
        }

        .home_c_c_r {
          width: 80%;
          position: absolute;
          top: -40px;
          left: -5px;
          // height: 60vh;
          // width: 40%;
          // height: 100%;
        }
      }

      .home_c_f {
        height: 27.5vh;
        background: rgba(77, 90, 144, 0.33);
        border-radius: 16px;
        padding: 15px 15px 0;
        display: flex;

        .home_c_f_l {
          width: 50%;

          // background: red;
          .home_c_f_t {
            display: flex;
            align-items: center;
            color: #fff;

            div {
              width: 15px;
              height: 15px;
              margin-right: 10px;
              background: #facc14;
            }
          }
        }

        // padding-top: 20px;
      }
    }

    .home_r {
      background: rgba(77, 90, 144, 0.33);
      height: 100%;
      border-radius: 16px;
      width: 340px;
      padding: 15px 20px 0;
      color: #ffffff;

      .home_r_t {
        display: flex;
        align-items: center;
        flex-wrap: wrap;

        .home_r_t_y {
          display: flex;
          align-items: center;
          margin-right: 30px;
          margin-bottom: 20px;

          &:nth-child(2n) {
            margin-right: 0;
          }

          .home_r_t_u {
            width: 50px;
            height: 50px;
            background: url(~@/assets/home/bei.png) no-repeat;
            background-size: 100% 100%;
            display: flex;
            align-items: center;
            justify-content: center;
            margin-right: 10px;

            img {
              width: 30px;
              height: 30px;
            }
          }

          .home_r_r {
            div {
              font-size: 20px;
              color: #408aff;
            }
          }
        }
      }
    }
  }
}

.home_l_m {
  margin-top: 8px;
}

.zan {
  text-align: center;
  color: #fff;

  img {
    width: 80px;
    height: 80px;
  }
}
</style>